var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.showIsAnalysisActiveStatus && _setup.analysisNotice
    ? _c("div", [
        _c(
          "div",
          {
            staticClass: "text-body-1 text-secondary--text",
            attrs: { "data-qa": "analysis_name" },
          },
          [
            _vm._v(
              "\n    " +
                _vm._s(
                  _vm.analysis.name
                    .replaceAll(" ", " ")
                    .replaceAll("&nbsp;", " ")
                ) +
                "\n  "
            ),
          ]
        ),
        _vm._v(" "),
        _vm.analysis.government_code
          ? _c("div", { staticClass: "text--secondary text-caption mt-1" }, [
              _vm._v("\n    " + _vm._s(_vm.analysis.government_code) + "\n  "),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-flex justify-space-between" },
          [
            _c("div", { staticClass: "text-body-2 text-error--text mt-2" }, [
              _vm._v("\n      " + _vm._s(_setup.analysisNotice) + "\n    "),
            ]),
            _vm._v(" "),
            _vm.analysis.is_in_cart &&
            _setup.hasUserPermission &&
            _vm.showCartButton
              ? _c(_setup.CartButton, {
                  attrs: {
                    "is-in-cart": _vm.analysis.is_in_cart,
                    partner: _vm.partner,
                    "disable-cart-button": _vm.disableCartButton,
                    "analysis-id": _vm.analysis.id,
                    "analysis-synonym-id": _vm.analysis.analysis_synonym_id,
                    "biomaterial-id": _vm.analysis.biomaterial_id,
                  },
                  on: { "click:delete-from-cart": _setup.handleDeleteFromCart },
                })
              : _vm._e(),
          ],
          1
        ),
      ])
    : _c(
        "div",
        {
          class: {
            "d-flex justify-space-between align-center": !_setup.isMobile,
          },
        },
        [
          _c("div", { staticClass: "d-flex flex-column" }, [
            _c(
              "div",
              {
                staticClass: "text-body-1 text--text",
                attrs: { "data-qa": "analysis_name" },
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.analysis.name
                        .replaceAll(" ", " ")
                        .replaceAll("&nbsp;", " ")
                    ) +
                    "\n    "
                ),
              ]
            ),
            _vm._v(" "),
            _vm.analysis.government_code
              ? _c(
                  "div",
                  { staticClass: "text--secondary text-caption mt-1" },
                  [
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm.analysis.government_code) +
                        "\n    "
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "mt-2",
                class: { "mt-2 d-flex align-center": !_setup.isMobile },
                attrs: { "data-qa": "analysis_details" },
              },
              [
                _c(_setup.AnalysisDetail, {
                  staticClass: "mr-4",
                  attrs: {
                    "data-qa": "analysis_execution_days",
                    icon: "ui-icon-clock",
                    text: _setup.executionDaysText,
                  },
                }),
                _vm._v(" "),
                !_setup.isMobile && _vm.analysis.biomaterial_name
                  ? _c("div", { staticClass: "mr-4 bg-gray-80--text" }, [
                      _vm._v("\n        •\n      "),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.analysis.biomaterial_name
                  ? _c(_setup.AnalysisDetail, {
                      class: { "mt-2": _setup.isMobile },
                      attrs: {
                        "data-qa": "analysis_biomaterial",
                        icon: "ui-icon-test-tube",
                        text: _vm.analysis.biomaterial_name,
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-flex justify-space-between mt-2" },
            [
              _c(_setup.PriceBlock, {
                style: {
                  width: _setup.isMobile ? "initial" : "max-content",
                  minWidth: "120px",
                },
                attrs: {
                  price: _vm.analysis.price,
                  price_with_discount: _vm.analysis.price_with_discount,
                },
              }),
              _vm._v(" "),
              _setup.hasUserPermission && _vm.showCartButton
                ? _c(_setup.CartButton, {
                    class: { "ml-6": !_setup.isMobile },
                    attrs: {
                      "is-in-cart": _vm.analysis.is_in_cart,
                      "analysis-id": _vm.analysis.id,
                      "analysis-synonym-id": _vm.analysis.analysis_synonym_id,
                      "biomaterial-id": _vm.analysis.biomaterial_id,
                      partner: _vm.partner,
                      "disable-cart-button": _vm.disableCartButton,
                    },
                    on: {
                      "click:add-to-cart": _setup.handleAddToCart,
                      "click:delete-from-cart": _setup.handleDeleteFromCart,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }